<div class="dashboard-shell">
  <section class="dashboard-header">
    <div>
      <h1>Dashboard</h1>

    </div>
    <span class="status-pill">Live</span>
  </section>

  <section class="dashboard-grid compact">
    <article class="dashboard-card connection-summary scoreboard">
      <div class="dashboard-top">
        <div class="dashboard-label">Connections Summary</div>
        <button class="refresh-btn" (click)="refreshConnectionStats()" [disabled]="loadingConnectionStats">
          <span *ngIf="loadingConnectionStats" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingConnectionStats ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>

      <div class="scoreboard-grid">
        <div class="mini-metric total">
          <div class="mini-label">Total</div>
          <div class="mini-value">{{ dashboard.total_connections | number }}</div>
        </div>
        <div class="mini-metric open">
          <div class="mini-label">Open</div>
          <div class="mini-value">{{ dashboard.total_open_connections | number }}</div>
        </div>
        <div class="mini-metric closed">
          <div class="mini-label">Closed</div>
          <div class="mini-value">{{ dashboard.total_closed_connections | number }}</div>
        </div>
        <div class="mini-metric joining">
          <div class="mini-label">Joining</div>
          <div class="mini-value">{{ dashboard.total_joining_connections | number }}</div>
        </div>
      </div>
    </article>
  </section>

  <section class="chart-grid chart-grid-three">
    <article class="dashboard-card chart-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Users by Age</div>
        <button class="refresh-btn" (click)="refreshAgeDashboard()" [disabled]="loadingAge">
          <span *ngIf="loadingAge" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingAge ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <kendo-chart [transitions]="false" [style.height.px]="220" (seriesClick)="showPointValue($event)">
        <!-- Native tooltip + shared: avoids Angular template CD flicker; stable across grouped columns -->
        <kendo-chart-tooltip [visible]="true" [shared]="true" [format]="fmtN0"></kendo-chart-tooltip>
        <kendo-chart-series>
          <kendo-chart-series-item
            *ngIf="ageShowMale"
            type="column"
            [data]="ageChartMale"
            color="#003566"
            name="Male"
          >
          </kendo-chart-series-item>
          <kendo-chart-series-item
            *ngIf="ageShowFemale"
            type="column"
            [data]="ageChartFemale"
            color="#ffc300"
            name="Female"
          >
          </kendo-chart-series-item>
          <kendo-chart-series-item
            *ngIf="ageShowOther"
            type="column"
            [data]="ageChartOther"
            color="#005f73"
            name="Other"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [categories]="ageChartCategories" [title]="titleAge">
            <kendo-chart-category-axis-item-labels [visible]="true"></kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item [title]="titleUsers">
            <kendo-chart-value-axis-item-labels [visible]="true" [format]="fmtN0"></kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
      </kendo-chart>
    </article>

    <article class="dashboard-card chart-card compact-gender-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Users by Gender</div>
        <button class="refresh-btn" (click)="refreshGenderDashboard()" [disabled]="loadingGender">
          <span *ngIf="loadingGender" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingGender ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <kendo-chart [transitions]="false" [style.height.px]="145" (seriesClick)="showPointValue($event)">
        <!-- Default pie tooltip includes value + %; avoid custom format so percentage stays visible -->
        <kendo-chart-tooltip [visible]="true"></kendo-chart-tooltip>
        <kendo-chart-legend position="bottom" [visible]="true"></kendo-chart-legend>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="pie"
            [data]="genderChartData"
            field="value"
            categoryField="category"
            colorField="color"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-chart>
    </article>

    <article class="dashboard-card chart-card compact-lastseen-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Users by Last Seen</div>
        <button class="refresh-btn" (click)="refreshLastSeenDashboard()" [disabled]="loadingLastSeen">
          <span *ngIf="loadingLastSeen" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingLastSeen ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <kendo-chart [transitions]="false" [style.height.px]="145" (seriesClick)="showPointValue($event)">
        <kendo-chart-tooltip [visible]="true" [format]="fmtN0"></kendo-chart-tooltip>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="bar"
            [data]="lastSeenChartData"
            field="last_seen_count"
            categoryField="last_seen"
            colorField="color"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [title]="titleLastSeen">
            <kendo-chart-category-axis-item-labels [visible]="true" [rotation]="0"></kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item [title]="titleUsers">
            <kendo-chart-value-axis-item-labels [visible]="true" [format]="fmtN0"></kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
      </kendo-chart>
    </article>

  </section>

  <section class="chart-grid chart-grid-two">
    <article class="dashboard-card chart-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Posted Questions vs Responses (By Hour)</div>
        <button class="refresh-btn" (click)="refreshPostedQuestionAndResponseDashboard()" [disabled]="loadingPostedQuestionAndResponse">
          <span *ngIf="loadingPostedQuestionAndResponse" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingPostedQuestionAndResponse ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <kendo-chart [transitions]="false" [style.height.px]="220" (seriesClick)="showPointValue($event)">
        <kendo-chart-tooltip [visible]="true" [shared]="true" [format]="fmtN0"></kendo-chart-tooltip>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="line"
            [data]="postedQuestionSeries"
            color="#003566"
            name="Questions"
          >
          </kendo-chart-series-item>
          <kendo-chart-series-item
            type="line"
            [data]="postedResponseSeries"
            color="#ffc300"
            name="Responses"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [categories]="postedChartCategories" [title]="titleHour">
            <kendo-chart-category-axis-item-labels [visible]="true"></kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item [title]="titleCount">
            <kendo-chart-value-axis-item-labels [visible]="true" [format]="fmtN0"></kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
      </kendo-chart>
    </article>

    <article class="dashboard-card chart-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Activities by Day of Week</div>
        <button class="refresh-btn" (click)="refreshActivitiesByDayOfWeekDashboard()" [disabled]="loadingActivitiesByDayOfWeek">
          <span *ngIf="loadingActivitiesByDayOfWeek" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingActivitiesByDayOfWeek ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <kendo-chart [transitions]="false" [style.height.px]="220" (seriesClick)="showPointValue($event)">
        <kendo-chart-tooltip [visible]="true" [format]="fmtN0"></kendo-chart-tooltip>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="column"
            [data]="activitiesChartSeries"
            color="#005f73"
            name="Activities"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [categories]="activitiesChartCategories" [title]="titleDay">
            <kendo-chart-category-axis-item-labels [visible]="true"></kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item [title]="titleActivities">
            <kendo-chart-value-axis-item-labels [visible]="true" [format]="fmtN0"></kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>
      </kendo-chart>
    </article>

    <article class="dashboard-card chart-card">
      <div class="dashboard-top">
        <div class="dashboard-label">Categories (All)</div>
        <button class="refresh-btn" (click)="refreshCategoryCountDashboard()" [disabled]="loadingCategoryCount">
          <span *ngIf="loadingCategoryCount" class="spinner-border spinner-border-sm refresh-spinner" role="status" aria-hidden="true"></span>
          {{ loadingCategoryCount ? 'Refreshing...' : 'Refresh' }}
        </button>
      </div>
      <div class="category-table-wrap">
        <table class="table table-sm category-table mb-0">
          <thead>
            <tr>
              <th>Category</th>
              <th class="text-end">Posted Count</th>
              <th class="text-center">Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of categoryCountDashboard">
              <td>{{ item.name }}</td>
              <td class="text-end">{{ item.category_count | number }}</td>
              <td class="text-center">
                <span class="category-badge" [class.challenge]="item.is_challenge" [class.standard]="!item.is_challenge">
                  {{ item.is_challenge ? 'Challenge' : 'Question' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </section>
</div>